export enum StructCapCRMStatus {
  INITIAL_INBOUND = 'INITIAL_INBOUND',
  NDA_IN_PROCESS = 'NDA_IN_PROCESS',
  EARLY_REVIEW = 'EARLY_REVIEW',
  DEAL_TEAM_WORKING_UP = 'DEAL_TEAM_WORKING_UP',
  TERM_SHEET_SENT = 'TERM_SHEET_SENT',
  TERM_SHEET_SIGNED = 'TERM_SHEET_SIGNED',
  CLOSED = 'CLOSED',

  ON_HOLD = 'ON_HOLD',

  DEAD = 'DEAD',

  PASSED_FLAGGED_FOR_FOLLOW_UP = 'PASSED_FLAGGED_FOR_FOLLOW_UP',
  FOLLOW_UP_REACTIVATED = 'FOLLOW_UP_REACTIVATED',
}

export const StructCapCRMStatusLabels: Record<StructCapCRMStatus, string> = {
  [StructCapCRMStatus.INITIAL_INBOUND]: 'Initial Inbound',
  [StructCapCRMStatus.NDA_IN_PROCESS]: 'NDA In Process',
  [StructCapCRMStatus.EARLY_REVIEW]: 'Early Review',
  [StructCapCRMStatus.DEAL_TEAM_WORKING_UP]: 'Deal Team Working Up',
  [StructCapCRMStatus.TERM_SHEET_SENT]: 'Term Sheet Sent',
  [StructCapCRMStatus.TERM_SHEET_SIGNED]: 'Term Sheet Signed',
  [StructCapCRMStatus.CLOSED]: 'Closed',
  [StructCapCRMStatus.ON_HOLD]: 'On Hold',
  [StructCapCRMStatus.DEAD]: 'Dead',
  [StructCapCRMStatus.PASSED_FLAGGED_FOR_FOLLOW_UP]: 'Passed - Flag for Follow Up',
  [StructCapCRMStatus.FOLLOW_UP_REACTIVATED]: 'Follow Up - Reactivated',
};

export const STRUCT_CAP_BLOCKING_STATUSES = [StructCapCRMStatus.PASSED_FLAGGED_FOR_FOLLOW_UP, StructCapCRMStatus.ON_HOLD, StructCapCRMStatus.DEAD];
